import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, Button, CardFooter } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import StudyCard from '../../components/Study/StudyCard.jsx'
import { ArrowCircleRight } from "phosphor-react"
import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class Study extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            courses: [],
            page: 0,
            limit: 1000,
            noCourses: false,
            activeTags: [],
            filters: [],
            totalItems: 0,
            dataLoaded: false,
        }
        this.toggleBtn = this.toggleBtn.bind(this)
        this.addToFilters = this.addToFilters.bind(this)
    }

    getCourses(page, limit, lang, accessToken, filters = []) {
        return new Promise((resolve, reject) => {
            api.getCourses(page, limit, lang, accessToken, filters)
                .then((res) => {
                    resolve(res)
                })
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    toggleBtn(id) {
        let activeTags = this.state.activeTags
        if (activeTags.includes(id)) {
            const index = activeTags.indexOf(id)
            activeTags.splice(index, 1)
        } else {
            activeTags.push(id)
        }
        this.setState({ activeTags })
    }

    updateFilters(name, value) {
        return new Promise((resolve, reject) => {
            try {
                let filters = this.state.filters
                const names = filters.map((filter) => filter.name)
                if (!filters.length) {
                    resolve([{ name, values: [value] }])
                } else if (!names.includes(name) && filters.length) {
                    filters.push({ name, values: [value] })
                    resolve(filters)
                } else {
                    filters.forEach((filter, filterIndex) => {
                        if (filter.name === name) {
                            if (!filter.values.includes(value)) {
                                filter.values.push(value)
                            } else {
                                const vlueIndex = filter.values.indexOf(value)
                                filter.values.splice(vlueIndex, 1)
                                if (!filter.values.length) filters.splice(filterIndex, 1)
                            }
                        }
                    })
                    resolve(filters)
                }
            } catch (e) {
                reject(e)
            }
        })
    }

    async addToFilters(name, value) {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const filters = await this.updateFilters(name, value)
        const courses = await this.getCourses(this.state.page, this.state.limit, lang, token, filters)
        this.setState({ filters, courses, page: 1 })
    }

    componentWillMount() {
        const accessToken = cookies.get('accessToken')
        this.getCourses(this.state.page, this.state.limit, this.props.i18n.language, accessToken).then((courses) => {
            if (!courses.length) this.setState({ noCourses: true, dataLoaded: true })
            else this.setState({ noCourses: false })
            this.setState({ courses, dataLoaded: true })
        }).catch(() => this.setState({ noCourses: true, dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <div className="content custom-bg position-relative">
                <Row className="w-100 mx-0">
                    <Col xs={12} md={12} className="px-0">
                        <div className="page-title">
                            <div className="float-left w-100">
                                {
                                    this.state.dataLoaded ?
                                        <h1 className="title news-dashboard xl-font-size">{t('study-study')}</h1>
                                        :
                                        <Skeleton className="title news-dashboard xl-font-size ml-40px" width={'20%'} />
                                }

                            </div>
                        </div>

                        <div className="col-xl-12">
                            <section>
                                <div className="content-body news-bg">
                                    {' '}
                                    <div className="row">
                                        <div className="col-12 news-col">
                                            {
                                                this.state.noCourses ?
                                                    <Card className="nostudy-card">
                                                        <CardHeader className="lg-font-size">{t('study-no-courses')}</CardHeader>
                                                        <CardBody className="md-font-size">{t('study-available')}</CardBody>
                                                        <div className="horizontal-whitespace"></div>
                                                        <CardFooter>
                                                            <Button className="nostudy-btn" onClick={() => this.props.history.push('/catalog-route')}>
                                                                <ArrowCircleRight size={20} className="primary" />
                                                                <span className="text sm-font-size">{t('study-catalog')}</span>
                                                            </Button>
                                                        </CardFooter>
                                                    </Card>
                                                    : ''
                                            }
                                            {
                                                this.state.dataLoaded ?
                                                    this.state.courses.map((course, index) => (
                                                        <StudyCard key={`course-${course.id}-${index}`}
                                                            id={course.id}
                                                            access={course.access || {}}
                                                            userGrade={course.userGrade}
                                                            image={course.image}
                                                            title={course.title}
                                                            desc={course.desc}
                                                            tags={course.tags || []}
                                                            totalPartners={course.totalPartners || 0}
                                                            partners={course.partners || []}
                                                            likes={course.likes || 0}
                                                            catalogType={course.catalogType}
                                                            type={course.type}
                                                            themes={course.themes || []}
                                                            programTitle={course.programTitle}
                                                            blocked={course.blocked}
                                                            certificate={course.certificate || {}}
                                                            activeTags={this.state.activeTags}
                                                            toggleBtn={this.toggleBtn}
                                                            addToFilters={this.addToFilters}
                                                            catalog={course.catalog}
                                                            complete={course.complete}
                                                            showStartButton={course.showStartButton}
                                                            showExtendButton={course.showExtendButton}
                                                            props={this.props}
                                                        />
                                                    ))
                                                    :
                                                    <StudyCard skeleton={true} props={this.props} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

Study.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(Study)



// WEBPACK FOOTER //
// ./src/views/Study/Study.jsx